import { EntryWithPredictions } from '@staycool/contests-types/entry';
import { createStores } from './store/utils';
import { PredictionStatus } from '@staycool/contests-types/prediction';

export const contestSelections = createStores({
    activeEntry: null as null | EntryWithPredictions,
    entries: [] as EntryWithPredictions[],
    selections: {} as Record<string, { marketId: number; outcomeId: number; matchId: number }[]>,
    initialSelections: {} as Record<
        string,
        { marketId: number; outcomeId: number; matchId: number; status?: PredictionStatus }[]
    >,
});
